import React from 'react'
import combineReducers from '../utils/combineReducers'
import userDetailsReducer from '../state/get-user-details/reducer'
import userPermissionsReducer from '../state/get-user-permissions/reducer'
import getUserDetails from '../state/get-user-details/actions'
import getUserPermissions from '../state/get-user-permissions/actions'
//import {getUserDetails as getUserDetailsApi} from '../services/auth'

const UserContext = React.createContext(null)

function UserContextProvider(props) {
  // [A]
  const [state, dispatch] = React.useReducer(
    combineReducers({details: userDetailsReducer, permissions: userPermissionsReducer})
  )

  const getDetails = React.useCallback(() => getUserDetails(dispatch), [])
  const getPermissions = React.useCallback(() => getUserPermissions(dispatch), [])

  React.useEffect(() => {
    getUserDetails(dispatch)
    getUserPermissions(dispatch)
  }, [])

  const value = {
    getDetails,
    getPermissions,
    dispatch,
    ...state,
  }

  // [B]
  return <UserContext.Provider value={value}>{props.children}</UserContext.Provider>
}

const UserContextConsumer = UserContext.Consumer

export {UserContext, UserContextProvider, UserContextConsumer}
